import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { VendorService } from '../vendors/vendor.service';
import { NgSelectComponent } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-product-vendor-mapping',
  imports: [CommonModule, FormsModule, NgSelectComponent],
  templateUrl: './product-vendor-mapping.component.html',
  styleUrl: './product-vendor-mapping.component.scss',
})
export class ProductVendorMappingComponent {
  private vendorService = inject(VendorService);
  private toastr = inject(ToastrService);
  vendors: any[] = [];
  filteredVendors: any[] = [];
  products: any[] = [];

  selectedVendorId: string = '';
  selectedNewVendorId: string | null = null;
  showReplace: boolean = false;

  constructor() {
    this.getAllVendors();
  }

  getAllVendors() {
    this.vendorService.getAllVendorsList().subscribe((res: any) => {
      this.vendors = res || [];
    });
  }

  onVendorChange(vendor: any) {
    this.selectedVendorId = vendor.id;
    this.filteredVendors = this.vendors.filter(
      (v) => v.id !== this.selectedVendorId,
    );
    this.vendorService.getProductsByVendorId(this.selectedVendorId).subscribe(
      (res: any) => {
        this.products = res;
      },
      (error) => {
        console.error('Error fetching products for vendor:', error);
      },
    );
  }

  replaceVendor() {
    if (!this.selectedVendorId || !this.selectedNewVendorId) return;

    const body = {
      oldVendorId: this.selectedVendorId,
      newVendorId: this.selectedNewVendorId,
    };

    this.vendorService.replaceVendor(body).subscribe(
      (res: any) => {
        this.toastr.success('Vendor replaced successfully');
        this.showReplace = false;
        this.selectedNewVendorId = null;
      },
      (error) => {
        console.error('Error replacing vendor:', error);
      },
    );
  }

  cancelReplace() {
    this.showReplace = false;
    this.selectedNewVendorId = null;
  }
}
